import React from 'react';
import styled from 'styled-components';

interface AvatarProps {
  src: string;
  alt: string;
}

const StyledAvatar = styled.img`
  width: 186px;
  height: 186px;
  border-radius: 50%;
  object-fit: cover;
  border: 4px solid #f4ede8;
`;

const Avatar: React.FC<AvatarProps> = ({ src, alt }) => {
  return <StyledAvatar src={src} alt={alt} />;
};

export default Avatar;
